// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__07khB","spinner-fullscreen":"Loading_spinner-fullscreen__XdOVL","spinner-fullscreen-spinner":"Loading_spinner-fullscreen-spinner__U7-Ym"};